import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tab navigation for the dynamic config wizard layout (BugZero design).
 * Tabs: Overview | Configuration | Risk Score (optional) | Managed Products | History
 *
 * Restyled to the BugZero token system — same tabs, ids, disable rules and
 * data-testids as before. Overview is always enabled; the rest require a
 * ServiceNow integration and a non-loading state, matching prior behavior.
 */
const TABS = [
  { id: '1', label: 'Overview', testid: 'overview-tab', alwaysEnabled: true },
  { id: '2', label: 'Configuration', testid: 'configuration-tab' },
  { id: '5', label: 'Risk Score', testid: 'risk-tab', riskOnly: true },
  { id: '7', label: 'Managed Products', testid: 'managed-products-tab' },
  { id: '6', label: 'History', testid: 'history-tab' }
];

export default function WizardTabNav({ activeTab, setActiveTab, snIntegrationCheck, hasBugRisk, loading = false }) {
  const toggleTab = tab => {
    if (activeTab !== tab && !loading) setActiveTab(tab);
  };

  const tabs = TABS.filter(t => (t.riskOnly ? hasBugRisk : true));

  return (
    <div
      className="bz-row bz-scroll"
      style={{
        gap: 2,
        borderBottom: '1px solid var(--line)',
        marginBottom: 20,
        overflowX: 'auto'
      }}
    >
      {tabs.map(t => {
        const on = activeTab === t.id;
        const disabled = (!t.alwaysEnabled && !snIntegrationCheck) || loading;
        return (
          <button
            key={t.id}
            type="button"
            data-testid={t.testid}
            onClick={() => {
              if (!disabled) toggleTab(t.id);
            }}
            disabled={disabled}
            style={{
              all: 'unset',
              whiteSpace: 'nowrap',
              cursor: disabled ? 'not-allowed' : 'pointer',
              padding: '10px 14px',
              fontSize: 'var(--fs-md)',
              fontWeight: on ? 600 : 500,
              color: disabled ? 'var(--ink-faint)' : on ? 'var(--ink)' : 'var(--ink-soft)',
              borderBottom: on ? '2px solid var(--prevent)' : '2px solid transparent',
              opacity: disabled && !on ? 0.6 : 1,
              transition: 'color .12s'
            }}
            onMouseEnter={e => {
              if (!disabled && !on) e.currentTarget.style.color = 'var(--ink)';
            }}
            onMouseLeave={e => {
              if (!disabled && !on) e.currentTarget.style.color = 'var(--ink-soft)';
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

WizardTabNav.propTypes = {
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  snIntegrationCheck: PropTypes.bool,
  hasBugRisk: PropTypes.bool,
  loading: PropTypes.bool
};
